import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography, fontWeights } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const languageFlagCss = css({
  display: 'inline-block',
  height: 21,
  marginRight: 16,
  paddingTop: 4,
  verticalAlign: 'top',
  width: 30,
  img: {
    width: '100%',
  },
});

export const languageTextCss = css({
  display: 'inline-block',
  verticalAlign: 'top',
});

export const languageNameCss = css(typography.effra16, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  wordBreak: 'break-word',
  [MediaQueries.mdAndUp]: {
    display: 'block',
  },
});

export const languageDescriptionCss = css(typography.effra14, {
  color: colorsPalette.grey60,
  marginLeft: 18,
  wordBreak: 'break-word',
  [MediaQueries.mdAndUp]: {
    marginLeft: 0,
    display: 'block',
  },
});
